/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Denah_S3Inputs */

const en_tut_denah_s3 = /** @type {(inputs: Tut_Denah_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add areas with **Tambah area**, or start from the team, focus, or social templates. Set name, kind, colour, capacity, position, and size; add desks with **Tambah meja**.`)
};

const id_tut_denah_s3 = /** @type {(inputs: Tut_Denah_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan area (**Tambah area**) atau mulai dari template ruang kerja tim, fokus, atau sosial. Atur nama, jenis, warna, kapasitas, posisi, dan ukuran; tambah meja dengan **Tambah meja**.`)
};

/**
* | output |
* | --- |
* | "Add areas with **Tambah area**, or start from the team, focus, or social templates. Set name, kind, colour, capacity, position, and size; add desks with **Ta..." |
*
* @param {Tut_Denah_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_denah_s3 = /** @type {((inputs?: Tut_Denah_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Denah_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_denah_s3(inputs)
	return en_tut_denah_s3(inputs)
});